import type { AddressInfo } from "features/dt-basic-setup/single-building/model/types";

export const REQUIRED_ADDRESS_FIELDS: (keyof AddressInfo)[] = ["name", "address", "postal_code", "city", "country"];
